/* CT 2026-09-22 (v19) — Barra inferior fija, solo movil.
 *
 * El boton "Mas" abre el menu hamburguesa que ya existe en el encabezado.
 * Los otros cuatro items son enlaces normales y no necesitan JavaScript — el de WhatsApp a
 * proposito, para que el escucha de atribucion de `layout/theme.liquid` lo tome como a
 * cualquier otro enlace `wa.me`.
 *
 * 🔴 SE ABRE EL CAJON QUE YA HAY, no uno nuevo: duplicarlo significaria mantener dos menus.
 * Y se esconde solo el BOTON del encabezado, nunca el <header-drawer> entero: si se escondiera
 * el elemento, el panel y su fondo se irian con el y el menu dejaria de abrirse. Es la misma
 * leccion del cajon de filtros del 2026-09-21.
 *
 * CT 2026-09-23 — el panel se cierra tambien TOCANDO FUERA, y "Mas" se vuelve una X mientras
 * esta abierto (el panel no tenia X propia: la del tema vive en el boton hamburguesa, que esta
 * escondido). Medido antes del cambio: tocar a la derecha del panel caia sobre la pagina y el
 * panel seguia abierto — el cajon del tema no tiene capa de fondo.
 * 🔴 El toque de fuera SE CONSUME (no activa lo que haya debajo): es lo que espera quien toca
 * fuera de un panel para cerrarlo. La excepcion es la propia barra: un toque en "Inicio" o
 * "WhatsApp" cierra el panel y ademas hace lo suyo, porque ahi la intencion es clara.
 */
(() => {
  const MOVIL = window.matchMedia('(max-width: 749px)');
  if (!MOVIL.matches) return;

  const mas = document.querySelector('[data-ct-mas]');
  if (!mas) return;

  const detalles = () => document.querySelector('#header-drawer-menu-mobile details, header-drawer details');

  // Se cierra con el mismo camino que lo abre: clic en el <summary>. El tema engancha ahi el
  // bloqueo del desplazamiento del fondo y el foco; con `open = false` a mano quedaria a medias.
  const alternar = det => {
    const sum = det.querySelector('summary');
    if (sum) sum.click(); else det.open = !det.open;
  };

  function alTocarFuera(e) {
    const det = detalles();
    if (!det || !det.open) return;
    // Todo lo que vive dentro del <details> se deja pasar: el panel Y el <summary> del tema.
    // 🔴 Medido: el clic con el que ESTE MISMO codigo cierra el panel (en el <summary>) pasaba
    // por aca, se tomaba como 'fuera' y se cancelaba — el panel no se cerraba nunca.
    if (det.contains(e.target)) return;
    if (mas.contains(e.target)) return;            // "Mas" alterna por su cuenta
    const enBarra = e.target.closest && e.target.closest('.ct-barra-movil');
    if (!enBarra) { e.preventDefault(); e.stopPropagation(); }
    alternar(det);
  }

  const reflejar = det => {
    const abierto = !!det && det.open;
    mas.classList.toggle('ct-barra-movil__item--abierto', abierto);
    mas.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    if (abierto) document.addEventListener('click', alTocarFuera, true);
    else document.removeEventListener('click', alTocarFuera, true);
  };

  const det0 = detalles();
  if (det0) det0.addEventListener('toggle', () => reflejar(det0));

  mas.addEventListener('click', () => {
    const det = detalles();
    if (!det) { window.location.href = '/collections/catalogo-de-telas-textiles-tejidos'; return; }
    alternar(det);
  });
})();

/* CT 2026-09-23 (tarde) — CARRITO EN MOVIL: bolita de la barra y SIN cajon lateral.
 *
 * (1) LA BOLITA COPIA A LA DEL ENCABEZADO. El tema, al agregar o cambiar una cantidad, vuelve a
 *     dibujar la seccion `cart-icon-bubble` dentro de `#cart-icon-bubble` (que en movil esta
 *     escondido, pero sigue en la pagina). Se observa ese nodo y se copia el numero: una sola
 *     fuente, sin pedir /cart.js y sin una segunda cuenta que pueda quedar desfasada.
 *
 * (2) EL CAJON NO SE ABRE EN MOVIL. `product-form.js` agrega, redibuja las secciones del cajon y
 *     del contador (`renderContents`), muestra el aviso del tema (`cart_success`) y al final llama
 *     a `cart-drawer.open()`. Se anula SOLO ese `open`: el contador y el aviso siguen igual y el
 *     cliente se queda en la ficha. Para ver el carrito, la barra lleva a /cart.
 *     🔴 No se toca `cart_type` en los ajustes: es global y en PC el cajon tiene que seguir.
 *     Se sobreescribe la propiedad en la INSTANCIA, no en la clase del tema: si el elemento
 *     todavia no se actualizo, la propiedad propia igual tapa al metodo de la clase despues.
 */
(() => {
  const MOVIL = window.matchMedia('(max-width: 749px)');
  if (!MOVIL.matches) return;

  // (2)
  const cajon = document.querySelector('cart-drawer');
  if (cajon) {
    cajon.open = function () {};
  }

  // (1)
  const salida = document.querySelector('[data-ct-barra-cuenta]');
  const fuente = document.getElementById('cart-icon-bubble');
  if (!salida || !fuente) return;
  const leer = () => {
    const n = fuente.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    return n ? n.textContent.trim() : null;
  };
  /* CT 2026-09-25 — AL AGREGAR, EL CARRITO DE LA BARRA SE MUEVE (pedido de Camilo, referencia MercadoLibre): el ícono
   * da un salto con un giro corto y la bolita un pulso, y ahí aparece el número nuevo. Solo cuando la cantidad SUBE.
   * Web Animations sobre `transform`: la anima el compositor, sin clases ni recálculo de estilos en el hilo principal
   * (se está midiendo el INP). Con "reducir movimiento" activado en el teléfono, no se anima. */
  const icono = salida.closest('.ct-barra-movil__icono');
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animar = () => {
    if (quieto.matches || !icono || !icono.animate) return;
    icono.animate([
      { transform: 'translateY(0) rotate(0)' },
      { transform: 'translateY(-6px) rotate(-12deg)', offset: 0.3 },
      { transform: 'translateY(0) rotate(8deg)', offset: 0.6 },
      { transform: 'translateY(0) rotate(0)' }
    ], { duration: 550, easing: 'ease-out' });
    salida.animate([
      { transform: 'scale(1)' }, { transform: 'scale(1.45)', offset: 0.4 }, { transform: 'scale(1)' }
    ], { duration: 450, delay: 120, easing: 'ease-out' });
  };
  const copiar = () => {
    const n = leer();
    if (n !== null && n !== salida.textContent) {
      const subio = (parseInt(n, 10) || 0) > (parseInt(salida.textContent, 10) || 0);
      salida.textContent = n;
      if (subio) animar();
    }
  };
  if ('MutationObserver' in window) new MutationObserver(copiar).observe(fuente, { childList: true, subtree: true, characterData: true });
  copiar();
})();
